import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/skeleton';

interface ChatLoadingSkeletonProps {
  fullHeight?: boolean;
}

export function ChatLoadingSkeleton({ fullHeight }: ChatLoadingSkeletonProps) {
  return (
    <div
      className={cn('flex flex-col p-6', fullHeight ? 'h-full' : 'h-[600px]')}
    >
      <div className="flex flex-1 flex-col justify-end gap-4">
        {/* Outgoing message (right-aligned) */}
        <div className="flex justify-end">
          <div className="flex w-3/5 flex-col items-end gap-1.5">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-20 w-full rounded-lg" />
          </div>
        </div>

        {/* Incoming message (left-aligned) */}
        <div className="flex justify-start">
          <div className="flex w-2/5 flex-col gap-1.5">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-14 w-full rounded-lg" />
          </div>
        </div>

        {/* Another outgoing message */}
        <div className="flex justify-end">
          <div className="flex w-1/2 flex-col items-end gap-1.5">
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-16 w-full rounded-lg" />
          </div>
        </div>
      </div>

      {/* Input area skeleton */}
      <div className="mt-4 border-t pt-4">
        <Skeleton className="h-10 w-full rounded-lg" />
      </div>
    </div>
  );
}
